import { RegisterClass } from "core/Misc/typeStore";
import { RewardGraphBuildState } from "../rewardGraphBuildState";
import { RewardGraphNode } from "../rewardGraphNode";
import { RewardGraphConnectionPoint } from "../rewardGraphConnectionPoint";
import { RewardGraphConnectionPointTypes } from "../rewardGraphConnectionPointTypes";

/**
 * Block used to generate the final reward
 */
export class RewardOutputBlock extends RewardGraphNode {

    /**
     * @param name defines the block name
     */
    public constructor(name: string) {
        super(name);

        this._isUnique = true;

        this.registerInput("reward", RewardGraphConnectionPointTypes.Float);
    }

    /**
     * Gets the current class name
     * @returns the class name
     */
    public override getClassName() {
        return "RewardOutputBlock";
    }
    /**
     * Gets the reward input component
     */
    public get reward(): RewardGraphConnectionPoint {
        return this._inputs[0];
    }

    protected override _buildBlock(state: RewardGraphBuildState) {
        state.rewardData = this.reward.getConnectedValue(state);
    }
}

RegisterClass("MELS.RewardOutputBlock", RewardOutputBlock);
